const MCEVENTS = {
    QUANTITY_CHANGED: 'mc:quantity:changed',
    TRIGGER: 'external:trigger',
    REFRESH: 'refresh:requested',
    CHILD_OPEN: 'child:opened',
    RESET: 'component:reset',
    REFRESH_REQUESTED: 'refresh:requested',
    FILTER_CHANGED: 'filter:changed',
    READY: 'mc:ready',
    WISHLIST_ADDED: 'mc:wishlist:added',         
    WISHLIST_REMOVED: 'mc:wishlist:removed',     
    WISHLIST_ERROR: 'mc:wishlist:error',
    COOKIE_CONSENT: 'mc:cookie:consent',              
    COOKIE_CLOSED: 'mc:cookie:closed',                
    CART_ADDED: 'mc:cart:added',                      
    CART_UPDATED: 'mc:cart:updated',                  
    CART_REMOVED: 'mc:cart:removed',                  
    CART_ERROR: 'mc:cart:error',                  
    SEARCH: 'mc:search',        
    INPUT_VALID: 'mc:input:valid',                      
    INPUT_ERROR: 'mc:input:error',                      
    FORM_SUBMIT: 'mc:form:submit',                  
    FORM_SUCCESS: 'mc:form:success',                
    FORM_ERROR: 'mc:form:error',                    
    FORM_COMPLETED: 'mc:form:completed',              
    FORM_VALIDATE: 'mc:form:validate',              
    EL_ACTIVATED: 'mc:el:activated',                
    EL_DEACTIVATED: 'mc:el:deactivated',            
    PLACES_LOCATED: 'mc:places:located',                
    PLACES_CHANGE: 'mc:places:change',                  
}